<template>
  <b-card v-if="data" no-body class="my-results-goal-overview">
    <b-row class="text-center mx-0">
      <!-- Total investido -->
      <b-col cols="12" md="6"
        class="border-bottom border-md-bottom-0 border-md-right d-flex align-items-center flex-column py-3">
        <b-icon icon="graph-up" variant="primary" font-scale="2"></b-icon>
        <b-card-text class="text-muted mt-0 mb-0">
          {{ $t("Total investido") }}
        </b-card-text>
        <h4 class="font-weight-bold mb-0 mt-1">
          {{ moneyFormat(totalInvested) }}
        </h4>
        <div>
          <small>{{ $t("licença + aporte") }}</small>
        </div>
      </b-col>

      <!-- Retorno total -->
      <b-col cols="12" md="6" class="d-flex align-items-center flex-column py-3">
        <b-icon icon="piggy-bank" variant="success" font-scale="2"></b-icon>
        <b-card-text class="text-muted mt-0 mb-0">
          {{ $t("Retorno total") }}
        </b-card-text>
        <h4 class="font-weight-bold mb-0 mt-1">
          {{ moneyFormat(totalReturn) }}
        </h4>
        <div>
          <small>{{ $t("rendimento + comissão") }}</small>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BCardText, BIcon } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardText,
    BIcon,
  },
  props: {
    data: {
      type: Object,
      default: () => { },
    },
    noHeader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    totalInvested() {
      return this.data.initialValue + this.data.licenseValue;
    },
    totalReturn() {
      return this.data.bonus + this.data.totalProfit;
    },
  },
  methods: {
    moneyFormat(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "USD",
      }).format(value);
    },
  },
};
</script>

<style scoped>
.my-results-goal-overview {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
}

.border-md-right {
  border-right: 1px solid #e9ecef !important;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
}

.border-md-bottom-0 {
  border-bottom: 0 !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.text-muted {
  color: #6c757d !important;
}

.font-weight-bold {
  font-weight: bold !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.text-center {
  text-align: center !important;
}

.d-flex {
  display: flex !important;
}

.flex-column {
  flex-direction: column !important;
}

.align-items-center {
  align-items: center !important;
}

@media (max-width: 767.98px) {
  .border-md-right {
    border-right: 0 !important;
  }

  .border-bottom {
    border-bottom: 1px solid #e9ecef !important;
  }

  .border-md-bottom-0 {
    border-bottom: 1px solid #e9ecef !important;
  }
}
</style>
